import {get, post, patch, destroy} from '../utils/FetchAPI';

export const getPage = (page, size, status) => get("/plant", {page: page, size: size, status})
export const uploadThumbnailImage = () => post("/plant/thumbnail")
export const uploadDetailImage = () => post("/plant/list-image")
export const getPlantById = (id) => get("/plant/"+id)
export const getPlantSuggestNotId = (id) => get("/plant/suggest-not-id/"+id)
export const createPlant = (body) => post("/plant", body)
export const updatePlant = (id, body) => patch("/plant/" + id, body)
export const deletePlant = (id) => destroy("/plant/"+id)